module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/goodjob/PxY_Foryou-e212829498ce0abebeb8510c80fdf785.jpg";